import apiClient from './api';
import { OrgWebhook, WebhookDeliveryLog, OrgWebhookEventType, ApiResponse } from '@/types';

class WebhooksService {
  async list(): Promise<OrgWebhook[]> {
    const response = await apiClient.get<ApiResponse<OrgWebhook[]>>('/settings/webhooks');
    return response.data.data || [];
  }

  async create(data: { url: string; description?: string; events: OrgWebhookEventType[] }): Promise<OrgWebhook> {
    const response = await apiClient.post<ApiResponse<OrgWebhook>>('/settings/webhooks', data);
    return response.data.data!;
  }

  async getById(id: string): Promise<OrgWebhook> {
    const response = await apiClient.get<ApiResponse<OrgWebhook>>(`/settings/webhooks/${id}`);
    return response.data.data!;
  }

  async update(id: string, data: Partial<{ url: string; description: string; events: OrgWebhookEventType[]; is_active: boolean }>): Promise<OrgWebhook> {
    const response = await apiClient.put<ApiResponse<OrgWebhook>>(`/settings/webhooks/${id}`, data);
    return response.data.data!;
  }

  async remove(id: string): Promise<void> {
    await apiClient.delete(`/settings/webhooks/${id}`);
  }

  async test(id: string): Promise<{ success: boolean; status?: number; error?: string }> {
    const response = await apiClient.post<ApiResponse<{ success: boolean; status?: number; error?: string }>>(`/settings/webhooks/${id}/test`);
    return response.data.data!;
  }

  async getDeliveryLogs(id: string, limit = 20, offset = 0): Promise<{ logs: WebhookDeliveryLog[]; total: number }> {
    const response = await apiClient.get<ApiResponse<{ logs: WebhookDeliveryLog[]; total: number }>>(`/settings/webhooks/${id}/deliveries?limit=${limit}&offset=${offset}`);
    return response.data.data!;
  }
}

export const webhooksService = new WebhooksService();
